import React, { Component } from 'react';

import Dialog from '../dialog';
import BTButtonDetails from '../../../../widgets/BTButtonDetails';

export default class BtButtonModal extends Component {

    constructor() {
        super();

        this.localState = {};
    }

    componentDidMount() {
        this.localState.ravenUuid = this.props.raven.raven_uuid;
    }

    componentDidUpdate() {

        if(this.props.raven && this.props.raven.raven_uuid)
        {
            if(this.props.raven.raven_uuid !== this.localState.ravenUuid)
            {
                this.localState.ravenUuid = this.props.raven.raven_uuid;
            }
        }
    }

    render() {
        const {stage, dataStore, raven} = this.props;

        return (
            <Dialog
                size="small"
                className="test"
                label={this.props.title}
                isOpen={this.props.isOpen}
                onClose={this.props.onClose}
                >
                    <div>
                        <div className="row">
                            <div className="col-12">
                                {
                                    raven && raven.raven_uuid ?
                                        <BTButtonDetails ravenUuid={raven.raven_uuid} stage={stage} dataStore={dataStore} />
                                        : <div className="alert alert-warning">No Raven Selected</div>
                                }
                            </div>
                        </div>
                    </div>
            </Dialog>
        );
    }

}
